import React, { useState, useEffect } from "react";
import "./navbarn.css";
import { Link } from 'react-router-dom';

const Navbarn = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [aboutusMenuOpen, setAboutusMenuOpen] = useState(false);
  const [admissionsMenuOpen, setAdmissionsMenuOpen] = useState(false);
  const [uploadMenuOpen, setUploadMenuOpen] = useState(false);
  const [messagesMenuOpen, setMessagesMenuOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const loc = window.location;
  const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
  const dynamicpart = '/logOut';
  const fullUrl = baseUrl + dynamicpart;

  const dynamicrequireAuth = '/requireAuth';
  const requireAuthurl = baseUrl + dynamicrequireAuth;

  useEffect(() => {
        const fetchRoles = async () => {
          //await dispatch(getOutlines(parsedObj));
          await fetch(requireAuthurl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            
          })
            .then(response => response.json())
            .then(data => {
              ///console.log("data contents db",data)  
              setUserRole(data)
              console.log("menu filter data", data)
          });
          
        };
    
        fetchRoles();

        
  }, []);

  const removetoken = () => {

    const fetchContents = async () => {
      await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      })
        .then(response => response.json())
        .then(data => {
          console.log("data contents log",data)
  
      });
      
    };

    fetchContents();

  }

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const toggleAboutusMenu = () => {
    setAboutusMenuOpen(!aboutusMenuOpen);
    setAdmissionsMenuOpen(false);
    setUploadMenuOpen(false);
    setMessagesMenuOpen(false);
  };

  const toggleAdmissionsMenu = () => {
    setAdmissionsMenuOpen(!admissionsMenuOpen);
    setAboutusMenuOpen(false);
    setUploadMenuOpen(false);
    setMessagesMenuOpen(false);
  };

  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to the top
  };

  /*

  const toggleUploadMenu = () => {
    setUploadMenuOpen(!uploadMenuOpen);
    setAboutusMenuOpen(false);
    setAdmissionsMenuOpen(false);
    setMessagesMenuOpen(false);
  };

  const toggleMessagesMenu = () => {
    setMessagesMenuOpen(!messagesMenuOpen);
    setUploadMenuOpen(false);
    setAboutusMenuOpen(false);
    setAdmissionsMenuOpen(false);

  }

  
 <li className="dropdownRa" onClick={toggleAdmissionsMenu}>
                          <p>Reports &#9662;</p>
                          {admissionsMenuOpen &&
                          <div className="dropdownRa-content">
                          
                          <Link
                            to = "/studentreport"
                            style={{ textDecoration: 'none', color: 'black', padding: 0}}
                          >
                          <p>Student Report</p>
                          </Link>
                          
                           
                          <Link
                            to = "/payslip"
                            style={{ textDecoration: 'none', color: 'black', padding: 0}}
                          >
                          <p>Pay Slip</p>
                          </Link>
                          
                          </div>
                          }
                      </li>


  */



    return (
      <>  
        <div className="navsectionmRa">
          <div className="schoollogonameRa">
              <img src="https://ucarecdn.com/6ad6da36-90f9-4700-aa14-04552f140096/-/preview/489x484/" className="logoimg" alt="SilwaneNatureReserve" />
          </div>
          <nav className="navbarmainRa">
              <div className="navbar-containerRa">
                  
                  <ul className={`navlistRa ${showMenu ? 'show-menuRa' : ''}`}>
                      <div className={`close-iconRa ${showMenu ? 'show-iconRa' : ''}`} onClick={toggleMenu}>
                          &times;
                      </div>
                       
                      <Link
                          to = "/"
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>Home</p>
                      </li>
                      </Link>

                      <Link
                          to = "/aboutus"
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>About Us</p>
                      </li>
                      </Link>

                       <Link
                          to = "/experiences"
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>Experiences</p>
                      </li>
                      </Link>

                      <Link
                          to = "/bookings"
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>Prices</p>
                      </li>
                      </Link>

                      <Link
                          to = "/gallery"
                          onClick={handleClick}
                          state = {{
                            data: { majorevents: "all", abt: "" }  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                          }}
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>Gallery</p>
                      </li>
                      </Link>

                      <Link
                          to = "/contactus"
                          style={{ textDecoration: 'none', color: 'black', padding: 0}}
                      >
                      <li>
                        <p>Contact Us</p>
                      </li>
                      </Link>
                    
                      
                  </ul>
                  <div className={`menu-iconRa ${showMenu ? 'hide-iconRa' : ''}`} onClick={toggleMenu}>
                  &#9776;
                  </div>
              </div>
          </nav>
        </div>
      </>
    );
  
};

export default Navbarn;